GatorSurvey.app.directive('gsQuestionResponse', ['surveyResponseService', QuestionResponse]);

function QuestionResponse(surveyResponseService) {
    return {
        require: '?ngModel',
        restrict: 'AE',
        scope: {
            qrResponse: '=?ngModel',
            qrModel: '=?',
            qrType: '=?',
            qrId: '=?',
            qrRowId: '=?',
            qrColId: '=?',
            qrIsOtherText: '=?',
            qrLabelClick: '=?'
        },
        controller: function ($scope, $rootScope) {
            var self = this;
        },
        link: function ($scope, elem, attrs) {
            
        }
    };
}
